const Default = () => (
  <div className="container">
    <p>
      Étape de process La Fourgale non reconnue. Vérifiez le champ template du
      statut en administration.
    </p>
  </div>
);

export default Default;
